import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getMetrics() {
  const data = await axiosInstance({
    url: "/metrics",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createMetric(formData) {
  const data = await axiosInstance({
    url: "/metrics",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateMetric(formData) {
  const data = await axiosInstance({
    url: `/metrics/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteMetric(id) {
  const data = await axiosInstance({
    url: `/metrics/${id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useMetrics() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.metrics],
    queryFn: getMetrics,
  });
  return data;
}

export function useUpdateMetric() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateMetric(formData),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.metrics]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddMetric() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createMetric(formData),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.metrics]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useDeleteMetric() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (id) => deleteMetric(id),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.metrics]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
